var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useMutation } from '@apollo/client';
import { makeUpdateFunction, } from './updateFunctions';
import { v4 as uuidv4 } from 'uuid';
import { isEffectivelyOnline } from './registerNetworkStatusCallback';
export function resultKeyNameFromField(field) {
    return field.alias ? field.alias.value : field.name.value;
}
export const getOperationFieldName = (operation) => resultKeyNameFromField(operation.definitions[0].selectionSet
    .selections[0]);
export const useOfflineMutation = (mutation, originalOptimisticResponse, queries) => {
    const [mutate, rest] = useMutation(mutation);
    const mutationField = mutation.definitions[0].selectionSet
        .selections[0].name.value;
    const offlineMutate = async (_a) => {
        var _b;
        var { variables, optimisticResponse = originalOptimisticResponse } = _a, props = __rest(_a, ["variables", "optimisticResponse"]);
        let finalOptimisticResponse = undefined;
        try {
            finalOptimisticResponse =
                typeof optimisticResponse === 'function'
                    ? await optimisticResponse(variables)
                    : optimisticResponse;
        }
        catch (e) {
            console.error(e);
        }
        const context = {
            id: uuidv4(),
            fieldName: mutationField,
            tracked: true,
            variables: (_b = variables) !== null && _b !== void 0 ? _b : {},
            queries: queries
                ? queries.map((queryDefinition) => (Object.assign(Object.assign({}, queryDefinition), { fieldName: getOperationFieldName(queryDefinition.query) })))
                : [],
            optimisticResponse: finalOptimisticResponse,
            props,
        };
        const update = makeUpdateFunction(mutationField, context);
        const mutation = mutate(Object.assign(Object.assign({}, props), { variables, optimisticResponse: finalOptimisticResponse, update,
            context }));
        return isEffectivelyOnline('3g')
            ? mutation
            : new Promise((resolve) => resolve({ data: finalOptimisticResponse, offline: true }));
    };
    return [offlineMutate, rest];
};
